import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const deleteCustomPlan = (planId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'DELETING_CUSTOM_PLAN' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.delete(`/ads/plans/${planId}`, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'DELETING_CUSTOM_PLAN_DONE',
              payload: {
                plan: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'DELETING_CUSTOM_PLAN_FAILED',
              payload: `Failed to delete custom plan`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'DELETING_CUSTOM_PLAN_FAILED',
            payload: `Failed to delete custom plan`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'DELETING_CUSTOM_PLAN_FAILED',
        payload: `Failed to delete custom plan`,
      });
    }
  };
};

export default deleteCustomPlan;
